import { IDENTITY_VOCABULARIES } from './identity.js';
import { PROBLEM_SHARED_VOCABULARIES } from './problem-shared.js';
import { RIDE_VOCABULARIES } from './ride.js';
import { SLICE_A } from './slice-a.js';
import { SLICE_ADMIN_A } from './slice-admin-a.js';
import { SLICE_ADMIN_B } from './slice-admin-b.js';
import { SLICE_B } from './slice-b.js';
import { SLICE_C } from './slice-c.js';
import { SLICE_CAREERS } from './slice-careers.js';
import { SLICE_CONSOLES } from './slice-consoles.js';
import { SLICE_D } from './slice-d.js';
import { SLICE_D490 } from './slice-d490.js';
import { SLICE_D493 } from './slice-d493.js';
import { SLICE_D496 } from './slice-d496.js';
import { SLICE_D561 } from './slice-d561.js';
import { SLICE_D576 } from './slice-d576.js';
import { SLICE_D580 } from './slice-d580.js';
import { SLICE_D587 } from './slice-d587.js';
import { SLICE_D592 } from './slice-d592.js';
import { SLICE_D593 } from './slice-d593.js';
import { SLICE_D631 } from './slice-d631.js';
import { SLICE_D615 } from './slice-d615.js';
import { SLICE_D616 } from './slice-d616.js';
import { SLICE_D597 } from './slice-d597.js';
import { SLICE_D632 } from './slice-d632.js';
import { SLICE_D636 } from './slice-d636.js';
import { SLICE_D637 } from './slice-d637.js';
import { SLICE_D638 } from './slice-d638.js';
import { SLICE_D639 } from './slice-d639.js';
import { SLICE_D853 } from './slice-d853.js';
import { SLICE_D870 } from './slice-d870.js';
import { SLICE_D877 } from './slice-d877.js';
import { SLICE_D879 } from './slice-d879.js';
import { SLICE_D882 } from './slice-d882.js';
import { SLICE_D883 } from './slice-d883.js';
import { SLICE_D898 } from './slice-d898.js';
import { SLICE_D642 } from './slice-d642.js';
import { SLICE_D643 } from './slice-d643.js';
import { SLICE_D647 } from './slice-d647.js';
import { SLICE_D669 } from './slice-d669.js';
import { SLICE_D737 } from './slice-d737.js';
import { SLICE_D739 } from './slice-d739.js';
import { SLICE_D775 } from './slice-d775.js';
import { SLICE_E } from './slice-e.js';
import { SLICE_S } from './slice-s.js';
/** Every vocabulary a screen may show (D577). One id, one place. */
export const CATALOG = [...RIDE_VOCABULARIES, ...IDENTITY_VOCABULARIES, ...PROBLEM_SHARED_VOCABULARIES, ...SLICE_A, ...SLICE_ADMIN_A, ...SLICE_ADMIN_B, ...SLICE_B, ...SLICE_C, ...SLICE_CAREERS, ...SLICE_CONSOLES, ...SLICE_D, ...SLICE_D490, ...SLICE_D493, ...SLICE_D496, ...SLICE_D576, ...SLICE_D580, ...SLICE_D587, ...SLICE_D592, ...SLICE_D593, ...SLICE_D561, ...SLICE_D615, ...SLICE_D616, ...SLICE_D597, ...SLICE_E, ...SLICE_S, ...SLICE_D631, ...SLICE_D632, ...SLICE_D636, ...SLICE_D637, ...SLICE_D638, ...SLICE_D639, ...SLICE_D642, ...SLICE_D643, ...SLICE_D647, ...SLICE_D669, ...SLICE_D737, ...SLICE_D739, ...SLICE_D775, ...SLICE_D853, ...SLICE_D870, ...SLICE_D877, ...SLICE_D879, ...SLICE_D882, ...SLICE_D883, ...SLICE_D898];
//# sourceMappingURL=index.js.map